if (!customElements.get('mm-card-gallery')) {
  customElements.define('mm-card-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      const track = this.querySelector('.mm-card-gallery__track');
      const slides = [...this.querySelectorAll('.mm-card-gallery__slide')];
      const dots = [...this.querySelectorAll('.mm-card-gallery__dot')];
      if (!track || !slides.length) return;
      let startX = 0;
      let startY = 0;
      let dragged = false;
      track.addEventListener('pointerdown', (event) => {
        startX = event.clientX;
        startY = event.clientY;
        dragged = false;
      }, { passive: true, signal });
      track.addEventListener('pointermove', (event) => {
        if (Math.abs(event.clientX - startX) > 10 || Math.abs(event.clientY - startY) > 10) {
          dragged = true;
        }
      }, { passive: true, signal });
      track.addEventListener('click', (event) => {
        if (dragged) {
          event.preventDefault();
          event.stopImmediatePropagation();
          dragged = false;
        }
      }, { capture: true, signal });
      track.addEventListener('scroll', () => {
        const width = track.clientWidth;
        if (!width) return;
        const index = Math.min(slides.length - 1, Math.max(0, Math.round(Math.abs(track.scrollLeft) / width)));
        dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
      }, { passive: true, signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}
